module.exports = __webpack_public_path__ + "static/media/park-your-equipment.078e5478.jpg";